import { render, staticRenderFns } from "./EditSocialMediaDialog.vue?vue&type=template&id=0e3bbaae&scoped=true&"
import script from "./EditSocialMediaDialog.vue?vue&type=script&lang=js&"
export * from "./EditSocialMediaDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditSocialMediaDialog.vue?vue&type=style&index=0&id=0e3bbaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3bbaae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
